import { Form } from 'react-bootstrap';

const Categorias = props => {
  return (
    <Form.Group controlId="formCategoria" className="mt-4">
      <Form.Label>*Categoria:</Form.Label>
      <Form.Select
        className="border border-secondary"
        required
        name="formCategoria"
        onChange={e => props.handleCategoria(e)}
      >
        <option value="">Selecione a Categoria</option>
        {props.getCategorias.map(item => (
          <option key={item.id} value={item.categoria}>
            {item.categoria}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default Categorias;
